import {getOnCallContactLink} from "../utils/commonUtils";
import {colorTextStatusError} from "@amzn/awsui-design-tokens/polaris";

export const UPLOAD_PREFIX = "UI_Input_Files";
export const TEMPLATE_FOLDER = "Templates";
export const FORMATS = ".csv,.xlsx,.txt,.xls,.xlsm,.json"
export const CREDENTIAL_FORMATS = ".xlsx,.xls,.xlsm"
export const ARTIFACTS_FORMAT = ".pdf,.png,.jpg,.jpeg,.docx,.xml," + FORMATS
export const DESC = "desc";
export const ASC = "asc";
export const CLIENT_NAME = "TwinService";
export const BRAAVOS_REPORT_SUCCESS_STATUS = "Success";
export const REMOTE_FILING_TRANSACTION_TYPE = "RemoteFiling";
// useCase_subUseCase pairs whose rows get the artifact View and Upload buttons, per page.
export const TRANSFORMATION_ARTIFACT_ENABLED_USE_CASES = ["PL_SAFT"];
export const FILING_ARTIFACT_ENABLED_USE_CASES = ["PL_SAFT_FILING"];

export const HMRC_VAT_RETURN_SHEET_NAME = "HMRC VAT Return";
export const HMRC_VAT_RETURN_FILE_NAME = "Workbook.xlsx";
export const WEBSITE_CLIENT_NAME = "TwinWebsite";
export const PHASTOS = "PHASTOS";
export const EXCALIBUR = 'Excalibur';
export const UNDERSCORE = '_';
export const FILING = 'FILING';
export const BACKSLASH =  '/';
export const PFX_EXTENSION = '.pfx';
export const SUBMISSION_TYPE_UStVA_2023 = 'UStVA_2023';
export const ADMINISTRATOR_ROLE = "Administrator";
export const APPROVER_ROLE = "Approver";
export const REVIEWER_ROLE = "Reviewer";
export const TOM_URL_PREFIX = "https://tom-na-iad.iad.proxy.amazon.com/tom-lite/invoice-search/invoice-details/";
export const EXCALIBUR_AUDIT_INFO = "EXCALIBUR_AUDIT_INFO";
export const TRANSACTION_DETAIL_INFO = "TRANSACTION_DETAIL_INFO";

// fileType values accepted by /excalibur/get_file_download_url. These mirror Excalibur's
// FileTypeEnum: a filing transaction's second artifact is its submission RECEIPT, while a
// transformation transaction's is the generated OUTPUT_FILE.
export const FILE_TYPE_INPUT_FILE = "INPUT_FILE";
export const FILE_TYPE_RECEIPT = "RECEIPT";
export const FILE_TYPE_OUTPUT_FILE = "OUTPUT_FILE";

// Task-row metadata (path, bucket) key pairs that carry the output file location when the
// outputFilePath / outputFileBucket columns are empty. Kept in the same order Excalibur
// resolves them: CESOP, then EFiler (DE VAT / PL CIT). The GIS pair (gisOutputFilePath /
// gisOutputFileBucket) is deliberately absent: it is the submitted xml, not a receipt.
export const OUTPUT_FILE_METADATA_KEY_PAIRS = [
    ["responseFileStoredPath", "responseFileStoredBucket"],
    ["outputFileKey", "outputBucket"]
];
export const COLOR_STATUS_ERROR = colorTextStatusError;
export const RIVER_WORKFLOW_URL = "https://river.amazon.com/workflow/run/wfss-6e60d1b3-73e2-4924-bd11-d371c6ed4ca2?org=Fintech";


export const DOCUMENT_TYPE = {
    ATTACHMENTS: "ATTACHMENTS",
    ADJUSTMENTS: "ADJUSTMENTS"
};

export const BULK_ADJUSTMENT_USE_CASE = {
    DST: "DST"
}

export const GET_PRESIGNED_URL_OPERATION_NAME = {
    UPLOAD: "UPLOAD",
    DOWNLOAD: "DOWNLOAD"
}

export const GET_ADJUSTMENT_DOCUMENT_PRESIGNED_URL_OPERATION_NAME = {
    UPLOAD: "UPLOAD",
    DOWNLOAD: "DOWNLOAD"
}

export const NOT_AUTHORIZED_FLASH_BAR_PROPS = {
    header: "User is not authorized to access this page",
    type: "error",
    content: (<div>{"In-case this is an error, kindly contact "}
        {getOnCallContactLink()}
    </div>),
};

export const INTERNAL_ERROR_FLASH_BAR_PROPS = {
    header: "Some internal error occurred. Please try again later",
    type: "error",
    content: (<div>{"If this issue persists, kindly contact "}
        {getOnCallContactLink()}
    </div>),
};
